module.exports = __webpack_public_path__ + "img/down-a.f2e7a1be.svg";